// extracted by mini-css-extract-plugin
export var articles = "sectionListOfArticles-module--articles--1516e";
export var publishedAt = "sectionListOfArticles-module--publishedAt--4f5b7";
export var readMore = "sectionListOfArticles-module--readMore--00d98";
export var richtext = "sectionListOfArticles-module--richtext--b712a";
export var section = "sectionListOfArticles-module--section--88fc9";
export var showMore = "sectionListOfArticles-module--showMore--a11e5";
export var tag = "sectionListOfArticles-module--tag--1b6ed";
export var thumbnail = "sectionListOfArticles-module--thumbnail--bf07e";